import { useContext, useEffect, useState } from "react";
import { getBatch, getSortedCollection, matchQuery } from "sprint-common-web";

import { EncodeSpecificationContext } from "../context/EncodeSpecificationContext";
import { EncodeSpecificationListingItem, mapToEncodeSpecificationListingItem } from "./EncodeSpecificationListingItem";
import { EncodeSpecificationListingFilters } from "./useEncodeSpecificationListingFilters";

export const useEncodeSpecificationListing = (filters: EncodeSpecificationListingFilters) => {
    const [listingItems, setListingItems] = useState<EncodeSpecificationListingItem[]>([]);
    const [totalItems, setTotalItems] = useState<number>(0);

    const { encodeSpecifications, isLoading } = useContext(EncodeSpecificationContext);

    useEffect(() => {
        if (encodeSpecifications.length) {
            saveData();
        }
    }, [
        filters.name,
        filters.type,
        filters.page,
        filters.pageSize,
        filters.sortBy,
        filters.sortOrder,
        encodeSpecifications
    ]);

    const saveData = (): void => {
        const encodeSpecificationListingItems = encodeSpecifications.map(mapToEncodeSpecificationListingItem);

        const sortedAndFilteredItems = getSortedAndFilteredItems(encodeSpecificationListingItems, filters);
        const itemsToDisplay = getBatch(sortedAndFilteredItems, filters.pageSize, filters.page);

        setTotalItems(sortedAndFilteredItems.length);
        setListingItems(itemsToDisplay);
    };

    return {
        listingItems,
        totalItems,
        isLoading,
        filters,
        saveData
    };
};

const getSortedAndFilteredItems = (
    items: EncodeSpecificationListingItem[],
    filter: EncodeSpecificationListingFilters
) => {
    const filteredItems = items.filter((item: EncodeSpecificationListingItem) => {
        if (filter.type) {
            return matchQuery(item.name, filter.name) && item.type === filter.type;
        }

        return matchQuery(item.name, filter.name);
    });

    return getSortedCollection(filteredItems, filter.sortBy, filter.sortOrder);
};
